// 权限管理路由
const general: any = [
    {
        path: 'order/list',
        name: 'order_list',
        meta: {
            pathTitle: 'channel_manage',
            title: '订单列表'
        },
        component: () => import('@/views/order/list.vue')
    },
    {
        path: 'order/orderDetail',
        name: 'orderDetail',
        meta: {
            pathTitle: 'order_list',
            title: '订单详情'
        },
        component: () => import('@/views/order/orderDetail.vue')
    },
    {
        path: 'order/invoice',
        name: 'finace_invoice',
        meta: {
            pathTitle: 'channel_manage',
            title: '发票列表'
        },
        component: () => import('@/views/order/invoice.vue')
    },
    {
        path: 'order/business',
        name: 'apply_list',
        meta: {
            pathTitle: 'channel_manage',
            title: '业务单列表'
        },
        component: () => import('@/views/order/business.vue')
    },
    {
        path: 'order/bussnessDetail',
        name: 'bussnessDetail',
        meta: {
            pathTitle: 'apply_list',
            title: '业务单详情'
        },
        component: () => import('@/views/order/bussnessDetail.vue')
    },
    {
        path: 'order/bussnessDetailYG',
        name: 'bussnessDetail',
        meta: {
            pathTitle: 'apply_yangguang_list',
            title: '业务单详情'
        },
        component: () => import('@/views/order/bussnessDetailYG.vue')
    },
    {
        path: 'order/bussnessDetailZS',
        name: 'bussnessDetail',
        meta: {
            pathTitle: 'apply_zhongsheng_list',
            title: '业务单详情'
        },
        component: () => import('@/views/order/bussnessDetailZS.vue')
    },
    {
        path: 'order/listN',
        name: 'order_v1_list',
        meta: {
            pathTitle: 'order_v1_list',
            title: '客户需求'
        },
        component: () => import('@/views/order/listN.vue')
    },
    {
        path: 'order/businessYG',
        name: 'apply_yangguang_list',
        meta: {
            pathTitle: 'apply_yangguang_list',
            title: '阳光业务单列表'
        },
        component: () => import('@/views/order/businessYG.vue')
    },
    {
        path: 'order/orderDetailYG',
        name: 'orderDetailYG',
        meta: {
            pathTitle: 'order_list',
            title: '订单详情'
        },
        component: () => import('@/views/order/orderDetailYG.vue')
    },
    {
        path: 'order/businessZS',
        name: 'apply_zhongsheng_list',
        meta: {
            pathTitle: 'apply_zhongsheng_list',
            title: '众升业务单列表'
        },
        component: () => import('@/views/order/businessZS.vue')
    },
    {
        path: 'order/orderDetailZS',
        name: 'orderDetailZS',
        meta: {
            pathTitle: 'order_list',
            title: '订单详情'
        },
        component: () => import('@/views/order/orderDetailZS.vue')
    },
]
export default general
